import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import AutoServe from 'PointOfSale/modules/servingOptionCategory/component/Autoserve';
import QuickServeItems from 'PointOfSale/modules/servingOptionCategory/component/Quickserve';
import CepTypeSelection from 'PointOfSale/modules/servingOptionCategory/component/CepTypesSelection';
import POSButton from 'PointOfSale/modules/common/component/Button';

import 'PointOfSale/styles/components/servingOptions.less';
import 'PointOfSale/styles/components/input.less';

const ServingMenuSubItems = props => {
  const {
    subMenus,
    disabled,
    currentSelectedMenu,
    handleOnClickSubMenu,
    columns,
    gridColumnClassName,
    isCepOn,
  } = props;
  const subMenuItems =
    currentSelectedMenu && subMenus
      ? subMenus[currentSelectedMenu]
      : [
          { Id: 1, Description: 'Auto Serve', selected: false },
          { Id: 2, Description: 'Quick Serve Items', selected: false },
        ];
  const subMenu = {
    'Auto Serve': isCepOn ? (
      <CepTypeSelection {...props} />
    ) : (
      <AutoServe label="Time Delay" {...props} />
    ),
    'Quick Serve Items': <QuickServeItems {...props} />,
  };

  return (
    <React.Fragment>
      <Grid.Row columns={columns}>
        {subMenuItems.map((item, index) => (
          <Grid.Column className={gridColumnClassName} key={index}>
            <POSButton
              label={item.Description}
              selected={item.selected}
              disabled={item.disabled || disabled}
              clickHandler={() => {
                handleOnClickSubMenu(item);
              }}
              fluid
            />
          </Grid.Column>
        ))}
        {props.children}
      </Grid.Row>
      <Grid.Row columns={columns}>
        {!disabled &&
          subMenuItems.map((item, index) => {
            if (item.selected) {
              return (
                <Grid.Column key={index}>
                  {subMenu[item.Description]}
                </Grid.Column>
              );
            } else {
              return <Grid.Column key={index} />;
            }
          })}
      </Grid.Row>
    </React.Fragment>
  );
};

ServingMenuSubItems.propTypes = {
  subMenus: PropTypes.object,
  currentSelectedMenu: PropTypes.string,
  gridColumnClassName: PropTypes.string,
  columns: PropTypes.number,
  disabled: PropTypes.bool,
  isCepOn: PropTypes.bool,
  handleOnClickSubMenu: PropTypes.func,
};
ServingMenuSubItems.defaultProps = {
  columns: 4,
  gridColumnClassName: 'servingOption-menuItems',
};
export default ServingMenuSubItems;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptionCategory/component/index.js